(function (){
    const u = navigator.userAgent;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isIOS) {
        window.document.body.style.letterSpacing = '-0.225px';
    }
})();